import React from 'react';

// Pagination component
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  return (
    <div className="pagination">
      <button 
        onClick={() => onPageChange(1)} 
        disabled={currentPage <= 1}
      >
        &laquo;
      </button>
      <button 
        onClick={() => onPageChange(currentPage - 1)} 
        disabled={currentPage <= 1}
      >
        &lt;
      </button>
      
      <span className="page-info">
        Page {currentPage} of {totalPages || 1}
      </span>
      
      <button 
        onClick={() => onPageChange(currentPage + 1)} 
        disabled={currentPage >= totalPages}
      >
        &gt;
      </button>
      <button 
        onClick={() => onPageChange(totalPages)} 
        disabled={currentPage >= totalPages}
      >
        &raquo;
      </button>
    </div>
  );
};

export default Pagination;
